<tidy-row [alignLastItemRight]="!!editLinkText()">
  <tidy-text [title]="heading()" />
  @if (editLinkText()) {
    <tidy-text
      [actionBody]="editLinkText()"
      (action)="editLinkClicked.emit()"
      class="link" />
  }
</tidy-row>

<tidy-card class="sp-summary-card">
  <div class="sp-li">
    <div class="sp-li-icon">
      <tidy-image [src]="'assets/svg/home-outline.svg'" />
    </div>
    <div class="sp-li-main">
      <div class="sp-li-title">Property Management</div>
      <div class="sp-li-sub">${{ baseMinimumPerUnit() }}/unit/mo minimum</div>
    </div>
    <div class="sp-li-amount">{{ feePercent() }}% of bookings</div>
  </div>
  @if (cleaningMaintenanceOn()) {
    <div class="sp-li">
      <div class="sp-li-icon">
        <tidy-image [src]="'assets/svg/construct-outline.svg'" />
      </div>
      <div class="sp-li-main">
        <div class="sp-li-title">Cleaning & Maintenance</div>
        <div class="sp-li-sub">Turnovers handled for you, end to end</div>
      </div>
      <div class="sp-li-amount">${{ cleaningMaintenanceDollars() }}/mo</div>
    </div>
  }
  <div class="sp-divider"></div>
  <div class="sp-total-row">
    <tidy-text [header]="'Monthly Total'" />
    <span class="sp-total-value">{{ monthlyTotal() }}</span>
  </div>
  @if (footnote()) {
    <div class="sp-total-note">{{ footnote() }}</div>
  }
</tidy-card>

<tidy-row class="extra-top-padding">
  <tidy-text [title]="'Optional Add-Ons'" />
</tidy-row>

<tidy-card class="sp-addon-card">
  <div class="sp-addon-head">
    <div class="sp-addon-title-wrap">
      <div class="sp-addon-title-row">
        <tidy-text [header]="'Cleaning & Maintenance'" />
        <span class="sp-badge">Most Popular</span>
      </div>
      <div class="sp-addon-price">
        <span class="sp-addon-price-value">${{ cleaningMaintenancePerUnit() }}</span>
        <span class="sp-addon-price-unit">/unit/mo</span>
      </div>
      <div class="sp-addon-waived">Waived for qualifying long-term rentals</div>
    </div>
    <tidy-toggle
      [toggled]="cleaningMaintenanceOn()"
      [disabled]="cleaningMaintenanceLocked()"
      (toggleChanged)="onCleaningMaintenanceToggle($event)" />
  </div>
  <tidy-text [body]="'TIDY coordinates your cleanings, turnovers, maintenance, inspections, security & restocking — no markups or per-job fees.'" />
</tidy-card>

<tidy-card class="sp-addon-card">
  <div class="sp-addon-head">
    <div class="sp-addon-title-wrap">
      <div class="sp-addon-title-row">
        <tidy-text [header]="'WiFi + Noise Sensor'" />
      </div>
      <div class="sp-addon-price">
        <span class="sp-addon-price-value">${{ WIFI_SENSOR_PER_YEAR }}</span>
        <span class="sp-addon-price-unit">/yr</span>
      </div>
    </div>
    <div class="sp-addon-toggle-gate" (click)="hardwareAddOnTapped.emit()">
      <tidy-toggle [toggled]="false" [disabled]="true" />
      <span class="sp-addon-toggle-shield"></span>
    </div>
  </div>
  <tidy-text [body]="'Guest WiFi, routing & noise monitoring in one device — collect guest contact info and stop noise complaints before they happen.'" />
</tidy-card>

<tidy-card class="sp-addon-card">
  <div class="sp-addon-head">
    <div class="sp-addon-title-wrap">
      <div class="sp-addon-title-row">
        <tidy-text [header]="'The Box'" />
      </div>
      <div class="sp-addon-price">
        <span class="sp-addon-price-value">${{ BOX_PER_YEAR }}</span>
        <span class="sp-addon-price-unit">/yr</span>
      </div>
    </div>
    <div class="sp-addon-toggle-gate" (click)="hardwareAddOnTapped.emit()">
      <tidy-toggle [toggled]="false" [disabled]="true" />
      <span class="sp-addon-toggle-shield"></span>
    </div>
  </div>
  <tidy-text [body]="'Delight your guests with spontaneous treats or guided games, run remotely — 5-star reviews on autopilot.'" />
</tidy-card>
